var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaveIcon0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 7480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cellular-Connection-path",
    d: "M4 12.6666H5C5.55228 12.6666 6 13.1143 6 13.6666V15.6666C6 16.2189 5.55228 16.6666 5 16.6666H4C3.44772 16.6666 3 16.2189 3 15.6666V13.6666C3 13.1143 3.44772 12.6666 4 12.6666V12.6666Z",
    fill: "#C5C6D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cellular-Connection-path_2",
    d: "M8.66699 10.6666H9.66699C10.2193 10.6666 10.667 11.1143 10.667 11.6666V15.6666C10.667 16.2189 10.2193 16.6666 9.66699 16.6666H8.66699C8.11471 16.6666 7.66699 16.2189 7.66699 15.6666V11.6666C7.66699 11.1143 8.11471 10.6666 8.66699 10.6666Z",
    fill: "#C5C6D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cellular-Connection-path_3",
    d: "M13.333 8.33337H14.333C14.8853 8.33337 15.333 8.78109 15.333 9.33337V15.6667C15.333 16.219 14.8853 16.6667 14.333 16.6667H13.333C12.7807 16.6667 12.333 16.219 12.333 15.6667V9.33337C12.333 8.78109 12.7807 8.33337 13.333 8.33337Z",
    fill: "#C5C6D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cellular-Connection-path_4",
    d: "M18 6H19C19.5523 6 20 6.44772 20 7V15.6667C20 16.219 19.5523 16.6667 19 16.6667H18C17.4477 16.6667 17 16.219 17 15.6667V7C17 6.44772 17.4477 6 18 6V6Z",
    fill: "#C5C6D2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveIcon0);
export default __webpack_public_path__ + "static/media/wave-icon-0.b2059625c297d8dfbb1280a671de36c7.svg";
export { ForwardRef as ReactComponent };